import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { normalizeMenuPath } from "../../utils/menuSelection";
class DefaultLink extends Component {
  constructor() {
    super();

    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    if (this.props.itemProps.hasSubMenu) {
      this.props.itemProps.toggleSubMenu(e);
    } else {
      this.props.itemProps.activateMe({
        newLocation: this.props.itemProps.to,
        selectedMenuLabel: this.props.itemProps.label,
      });
    }
  }
  render() {
    const { menuIcon, subMenuIcon, itemProps } = this.props;
    const isActive = !itemProps.hasSubMenu && Boolean(itemProps.to) &&
      normalizeMenuPath(itemProps.to) === normalizeMenuPath(this.props.selectedPath);
    if (itemProps.id === "Directories" || itemProps.id === "UiElements") {
      return <span className="g_heading">{itemProps.label}</span>;
    } else {
      return (
          <NavLink
            to={`${itemProps.to || "#"}`}
            aria-current={isActive ? "page" : undefined}
            onClick={(e) => this.onClick(e)}
            className={() => [itemProps.className, isActive ? menuIcon : subMenuIcon,
              isActive ? "np-menu-link--selected" : ""].filter(Boolean).join(" ")}
          >
            {itemProps.children[0].props.className
              ? itemProps.children
              : itemProps.label}

            {itemProps.hasSubMenu && (
              <i
                className="fa fa-chevron-down fs-9"
                style={{
                  float: "right",
                  marginTop: "4px", 
                }}
              />
            )}
          </NavLink>
      );
    }
  }
}
const mapStateToProps = (state) => ({
  subMenuIcon: state.settings.isSubMenuIcon,
  menuIcon: state.settings.isMenuIcon,
});

const mapDispatchToProps = (dispatch) => ({});
export default connect(mapStateToProps, mapDispatchToProps)(DefaultLink);
